var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subproject-area"},[(_vm.show)?_c('l-geoJson',{attrs:{"geojson":_vm.geoJson,"options":_vm.options,"optionsStyle":_vm.styles}}):_vm._e(),_vm._l((_vm.labels),function(ref,id){
var latlng = ref.latlng;
var icon = ref.icon;
var info = ref.info;
return (_vm.show)?_c('l-marker',{key:("subproject_label_" + id),attrs:{"lat-lng":latlng,"icon":icon},on:{"click":function($event){return _vm.$emit('change-location', { event: $event, location: info })}}}):_vm._e()})],2)}
var staticRenderFns = []

export { render, staticRenderFns }